<style scoped>
    .chanel_da h2{
        color: #000;
    }
    .chanel_da{
        color: #000;
        font-size: 12px;
    }
    .c_v{
        margin-top: 12px;
        margin-bottom: 12px;
    }
    .user-header-right, .channel-header-right {
        flex-basis: 1px !important;
    }
    .pur_p{
        background-color: #8293CA !important;
        color: #fff;
        padding: 10px 12px 14px 12px;
    }
    .home-wrapper .nav {
        min-height: 0px !important;
    }
    .home-wrapper .nav .container {
        min-height: 0px !important;
    }
</style>
<template>
    <div>
        <div v-bind:style=""
             class="channel-header-big profile-cover"
             v-show="showFirstHeader">
            <div class="container user-select full-width">
                <div class="cols-flex">
                    <div class="channel-header-left">
                        <!-- avatar -->
                        <div class="profile-avatar">
                            <router-link :to="'/l/' + 'india'">
                                <img src="https://images-eu.ssl-images-amazon.com/images/I/31vHYvFTadL._AC_SS350_.jpg"
                                      />
                            </router-link>
                        </div>
                        <!-- end avatar -->
                    </div>

                    <div class="channel-header-middle flex-align-center">
                        <div class="chanel_da">
                            <h2>India</h2> ()
                            <p class="color_black">
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                            </p>
                            <el-button round
                                       @click="$eventHub.$emit('submit')"
                                       v-if="!isGuest"
                                       size="mini"
                                       class="pur_p">
                                Submit a post here
                            </el-button>
                        </div>
                    </div>

                    <div class="channel-header-right">
                        <div class="xp">
                            <!--<div class="xp-number">-->
                            <!--{{ Store.page.channel.temp.subscribers_count }}-->
                            <!--</div>-->

                            <!--<div class="xp-text margin-bottom-1">-->
                            <!--Subscribers-->
                            <!--</div>-->

                            <subscribe v-if="!isGuest"
                                       subscribed-class="unsubscribe"
                                       unsubscribed-class="subscribe"></subscribe>
                        </div>



                        <div class="channel-admin-btn">

                            <el-tooltip :content="bookmarked ? 'Unbookmark this channel' : 'Bookmark this channel'"
                                        placement="bottom"
                                        transition="false"
                                        :open-delay="500">
                                <i class="v-icon h-yellow pointer"
                                   :class="bookmarked ? 'go-yellow v-unbookmark' : 'v-bookmark go-gray'"
                                   @click="bookmark"></i>
                            </el-tooltip>

                            <el-dropdown size="medium"
                                         type="primary"
                                         trigger="click"
                                         :show-timeout="0"
                                         :hide-timeout="0">
                                <i class="v-icon v-more-vertical darker-on-hover"></i>

                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="showModeratorsModal = true">
                                        Moderators
                                    </el-dropdown-item>

                                    <el-dropdown-item @click.native="showRulesModal = true">
                                        Rules
                                    </el-dropdown-item>

                                    <el-dropdown-item @click.native="block">
                                        Block/Unblock
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>


                            <!--<el-button round-->
                            <!--type="success"-->
                            <!--@click="$router.push('/l/' + $route.params.name + '/mod')"-->
                            <!--v-if="isModerator"-->
                            <!--size="mini">-->
                            <!--Moderation-->
                            <!--</el-button>-->

                            <el-button round
                                       type="warning"
                                       @click="$router.push('/l/' + $route.params.name + '/mod')"
                                       v-if="!isModerator && isHumtogAdministrator"
                                       size="mini">
                                Moderation
                            </el-button>
                        </div>


                    </div>
                </div>
            </div>
        </div>


        <moderators :visible.sync="showModeratorsModal"
                    v-if="showModeratorsModal"></moderators>
        <rules :visible.sync="showRulesModal"
               v-if="showRulesModal"></rules>
    </div>
</template>

<script>
    import Subscribe from '../components/SubscribeButton.vue';
    import Moderators from '../components/Moderators.vue';
    import Rules from '../components/Rules.vue';
    import Helpers from '../mixins/Helpers';

    export default {
        mixins: [Helpers],

        components: {
            Subscribe,
            Moderators,
            Rules
        },

        data() {
            return {
                showModeratorsModal: false,
                showRulesModal: false,
                showFirstHeader: true,
                efreshing: false
            };
        },

        created() {
            this.$eventHub.$on('scrolled-to-top', () => {
                this.showFirstHeader = true;
            });

            this.$eventHub.$on('scrolled-a-bit', () => {
                this.showFirstHeader = true;
            });
        },

        beforeDestroy() {
            this.$eventHub.$off('scrolled-to-top', () => {
                this.showFirstHeader = true;
            });

            this.$eventHub.$off('scrolled-a-bit', () => {
                this.showFirstHeader = false;
            });
        },

        sort() {
            return this.$route.query.sort ? this.$route.query.sort : 'serious';
        },
        methods: {

            refresh: _.debounce(
                function() {
                    this.refreshing = true;

                    Store.page.channel.clear();
                    Store.page.channel
                        .getSubmissions(this.sort,this.$route.params.name)
                        .then(() => {
                            this.refreshing = false;
                        })
                        .catch(() => {
                            this.refreshing = false;
                        });
                },
                200,
                { leading: true, trailing: false }
            ),


            block() {
                if (this.isGuest) {
                    this.mustBeLogin();
                    return;
                }

                app.$Progress.start();

                axios
                    .post(`/channels/${Store.page.channel.temp.id}/block`)
                    .then(response => {
                        app.$Progress.finish();

                        // blocked
                        if (response.status === 201) {
                            this.$message({
                                type: 'success',
                                message: `#${
                                    Store.page.channel.temp.name
                                    } is now blocked for you. You won't see submissions from #${
                                    Store.page.channel.temp.name
                                    } in your feed. `
                            });
                        } else if (response.status === 200) {
                            // unblocked
                            this.$message({
                                type: 'success',
                                message: `#${Store.page.channel.temp.name} is no longer blocked.`
                            });
                        }
                    })
                    .catch(error => {
                        app.$Progress.fail();
                    });
            },

            bookmark: _.debounce(
                function() {
                    if (this.isGuest) {
                        this.mustBeLogin();
                        return;
                    }

                    this.bookmarked = !this.bookmarked;

                    axios.post(`/channels/${Store.page.channel.temp.id}/bookmark`).catch(() => {
                        this.bookmarked = !this.bookmarked;
                    });
                },
                200,
                { leading: true, trailing: false }
            )
        },

        computed: {
            sort() {
                if (this.$route.name != 'channel-submissions') return null;

                if (this.$route.query.sort == 'relaxed') return 'relaxed';

                // if (this.$route.query.sort == 'serious') return 'serious';

                return 'serious';
            },

            bookmarked: {
                get() {
                    return Store.state.bookmarks.channels.indexOf(Store.page.channel.temp.id) !== -1 ? true : false;
                },

                set() {
                    if (Store.state.bookmarks.channels.indexOf(Store.page.channel.temp.id) !== -1) {
                        let index = Store.state.bookmarks.channels.indexOf(Store.page.channel.temp.id);
                        Store.state.bookmarks.channels.splice(index, 1);

                        let removeItem = Store.page.channel.temp.id;
                        Store.state.bookmarkedChannels = Store.state.bookmarkedChannels.filter(
                            channel => channel.id != removeItem
                        );

                        return;
                    }

                    Store.state.bookmarks.channels.push(Store.page.channel.temp.id);
                    Store.state.bookmarkedChannels.push(Store.page.channel.temp);
                }
            },

            date() {
                return moment(Store.page.channel.temp.created_at)
                    .utc(moment().format('MMM Do'))
                    .format('MMM Do');
            },

            isModerator() {
                return Store.state.moderatingAt.indexOf(Store.page.channel.temp.id) != -1;
            },

            coverBackground() {
                if (Store.page.channel.temp.cover_color == 'Red') {
                    return '#9a4e4e';
                } else if (Store.page.channel.temp.cover_color == 'Blue') {
                    return 'rgb(244, 245, 247)';
                } else if (Store.page.channel.temp.cover_color == 'Dark Blue') {
                    return '#2f3b49';
                } else if (Store.page.channel.temp.cover_color == 'Dark Green') {
                    return '#507e75';
                } else if (Store.page.channel.temp.cover_color == 'Bright Green') {
                    return 'rgb(117, 148, 127)';
                } else if (Store.page.channel.temp.cover_color == 'Purple') {
                    return '#4d4261';
                } else if (Store.page.channel.temp.cover_color == 'Orange') {
                    return '#ffaf40';
                } else if (Store.page.channel.temp.cover_color == 'Pink') {
                    return '#ec7daa';
                } else {
                    // userStore.cover_color == 'Black'
                    return '#424242';
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LocationHeader.vue